/// <amd-module name="SuiteCommerce.PagePrinter.Common.Utils"/>
define("SuiteCommerce.PagePrinter.Common.Utils", ["require", "exports", "underscore", "SuiteCommerce.PagePrinter.Common.Configuration"], function (require, exports, _, Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var profile = null;
    var RegistrationType;
    (function (RegistrationType) {
        // no login, no register, checkout as guest only
        RegistrationType["disabled"] = "disabled";
        // login, register, guest
        RegistrationType["optional"] = "optional";
        // login, register, no guest
        RegistrationType["required"] = "required";
        // login, no register, no guest
        RegistrationType["existing"] = "existing";
    })(RegistrationType || (RegistrationType = {}));
    var Utils = /** @class */ (function () {
        function Utils() {
        }
        Utils.imageFlatten = function (images) {
            var _this = this;
            var result = [];
            if ('url' in images && 'altimagetext' in images) {
                return [images];
            }
            Object.getOwnPropertyNames(images).forEach(function (key) {
                if (_.isArray(images[key])) {
                    result.push(images[key]);
                }
                else {
                    result.push(_this.imageFlatten(images[key]));
                }
            });
            return _.flatten(result);
        };
        Utils.addParamsToUrl = function (baseUrl, params, avoidDoubleRedirect) {
            if (avoidDoubleRedirect) {
                var newParams_1 = {};
                _.each(params, function (paramValue, paramKey) {
                    newParams_1['__' + paramKey] = paramValue;
                });
                params = newParams_1;
            }
            if (baseUrl && !_.isEmpty(params)) {
                var paramString = jQuery.param(params);
                var joinString = baseUrl.indexOf('?') !== -1 ? '&' : '?';
                return baseUrl + joinString + paramString;
            }
            return baseUrl;
        };
        Utils.parseUrlOptions = function (optionsString) {
            var urlOption = optionsString || '';
            if (urlOption && urlOption.indexOf('?') !== -1) {
                urlOption = _.last(urlOption.split('?'));
            }
            if (urlOption && urlOption.indexOf('#') !== -1) {
                urlOption = _.first(urlOption.split('#'));
            }
            var options = {};
            if (urlOption && urlOption.length > 0) {
                var tokens = urlOption.split(/&/g);
                var currentToken = [];
                while (tokens.length > 0) {
                    var firstElement = tokens.shift();
                    if (firstElement) {
                        currentToken = firstElement.split(/=/g);
                    }
                    if (currentToken && currentToken[0].length !== 0) {
                        options[currentToken[0]] = this.getDecodedURLParameter(currentToken[1]);
                    }
                }
            }
            return options;
        };
        Utils.getDecodedURLParameter = function (urlParameter) {
            if (urlParameter === void 0) { urlParameter = ''; }
            var position;
            var temporal;
            for (temporal = ''; (position = urlParameter.indexOf('%')) >= 0; urlParameter = urlParameter.substring(position + 3)) {
                temporal += urlParameter.substring(0, position);
                var extract = urlParameter.substring(position, position + 3);
                try {
                    temporal += decodeURIComponent(extract);
                }
                catch (e) {
                    temporal += extract;
                }
            }
            return temporal + urlParameter;
        };
        Utils.hidePrices = function () {
            return (this.getRegistrationType() !== RegistrationType.disabled &&
                Configuration_1.Configuration.get('siteSettings.requireloginforpricing', 'F') === 'T' &&
                !this.userProfileData.isloggedin);
        };
        Utils.getRegistrationType = function () {
            // registrationmandatory is 'T' when customer registration is disabled
            if (Configuration_1.Configuration.get('siteSettings.registration.registrationmandatory', null) === 'T') {
                return RegistrationType.disabled;
            }
            if (Configuration_1.Configuration.get('siteSettings.registration.registrationoptional', null) === 'T') {
                return RegistrationType.optional;
            }
            if (Configuration_1.Configuration.get('siteSettings.registration.registrationallowed', null) === 'T') {
                return RegistrationType.required;
            }
            return RegistrationType.existing;
        };
        Object.defineProperty(Utils, "userProfileData", {
            get: function () {
                if (profile) {
                    return profile;
                }
                return null;
            },
            set: function (profileData) {
                profile = profileData;
            },
            enumerable: true,
            configurable: true
        });
        return Utils;
    }());
    exports.Utils = Utils;
});
